const InnerNavbarStore = {
  namespaced: true,
  state: {
    breadcrumb_icon: '',
    breadcrumb_text: '',
  },
  mutations: {
    SET_BREADCRUMB_ICON(state, icon) {
      state.breadcrumb_icon = icon;
    },
    SET_BREADCRUMB_TEXT(state, text) {
      state.breadcrumb_text = text;
    },
  },
  actions: {
    setBreadcrumbCurrentIcon({ commit }, icon) {
      commit('SET_BREADCRUMB_ICON', icon);
    },
    setBreadcrumbCurrentText({ commit }, text) {
      commit('SET_BREADCRUMB_TEXT', text);
    },
  },
  getters: {
    getCurrentBreadcrumbIcon: (state) => (state.breadcrumb_icon),
    getCurrentBreadcrumbText: (state) => (state.breadcrumb_text),
  },
};

export default InnerNavbarStore;
